import React, {useContext, useState} from 'react';
import AdminSearchBox from "./AdminSearchBox"
import AdminUserListTable from "./AdminUserListTable";
import axios from "axios";
import authContext from "../../AuthProvider/authContext";

const AdminDashboard = () => {
    const {updateAuth} = useContext(authContext)
    const [isLoadingData, setLoadingData] = useState(false);
    const [tableList,setTableList] = useState([]);
    const [queryParam,setParams] = useState({limit: 50, page: 1, sort: 'created_at:desc'});

    const userList = (params = {limit: 50, page:1, sort: 'created_at:desc'})=> {
        return axios.get("/api/users",  {params})
            .then((res)=> {
                const values = res.data.data;
                setTableList(res.data.data);
                updateAuth({total: {active: values.total_active, inActive: values.total_inactive}});
                setLoadingData(false);
            })
            .catch(()=>{
                setLoadingData(false);
            });
    }

    const queryPersist = (key = "",value = "") =>{
        setParams((prev)=>({...prev,[key]:value,page:1}));
        const values = {...queryParam,[key]:value};
        userList(values);
    }

    const props = {isLoadingData,setLoadingData,userList,tableList,queryPersist};

    return (
        <div className="dashboard-content">
            <AdminSearchBox {...props}/>
            <AdminUserListTable {...props}/>
        </div>
    );
};

export default AdminDashboard;